import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { MenuItems, MenuItem } from '@home/src/app/layouts/sidebar/NavItems';
import { DealerSelectComponent } from '@app/shared/components/dealer-select/dealer-select.component';
import { GlobalService } from '@home/src/app/core/services/global/global.service';
import { Subject, takeUntil } from 'rxjs';
import { SideNavCarouselComponent } from '@app/shared/components/side-nav-carousel/side-nav-carousel.component';
import { SupportComponent } from '@home/src/app/Components/ResourseAndTools/support/support.component';

@Component({
  selector: 'app-side-nav',
  standalone: true,
  imports: [
    RouterModule,
    DealerSelectComponent,
    SideNavCarouselComponent,
    SupportComponent,
  ],
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css'],
})
export class SideNavComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  version: string = '';
  groupName: string | null = null;
  isClosed = true;
  menuItems: MenuItem[] = MenuItems;
  oemDepartments: { deptId: number; deptName: string }[] = [];
  showSupportPopup: boolean = false;
  user: any = null;

  get filteredMenuItems() {
    const role = this.globalService.getSelectedRole();
    const cleanedCode = role.replace(/\d+$/, '');
    const filteredItems = this.menuItems.filter((item: MenuItem) =>
      item.roles?.includes(cleanedCode),
    );
    return filteredItems || [];
  }

  constructor(
    private readonly router: Router,
    private readonly globalService: GlobalService,
  ) {}

  ngOnInit(): void {
    this.globalService.allOEMDepartments$
      .pipe(takeUntil(this.destroy$))
      .subscribe((depts) => {
        if (!depts || depts.length === 0) return;
        this.oemDepartments = depts;
        const index = this.menuItems.findIndex(
          (item) => item.label.toLocaleLowerCase() === 'department analysis',
        );
        if (index !== -1) {
          this.menuItems[index].children =
            this.menuItems[index].children?.filter((child: any) =>
              this.oemDepartments.some(
                (dept) =>
                  dept.deptName.toLowerCase() === child.label.toLowerCase(),
              ),
            ) || [];
        }
      });
    this.version = this.globalService.appVersion;
    this.globalService.groupName$
      .pipe(takeUntil(this.destroy$))
      .subscribe((name) => (this.groupName = name));

    this.globalService.isSideMenuClosed$
      .pipe(takeUntil(this.destroy$))
      .subscribe((closed) => (this.isClosed = closed));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  closeSideMenu(): void {
    this.globalService.updateIsSideMenuClosed(true);
    this.menuItems.forEach((item) => (item.childrenOpen = false));
  }

  expandSideMenu(event: MouseEvent, index: number | null = null): void {
    event.stopPropagation();
    this.globalService.updateIsSideMenuClosed(false);
    if (index !== null) {
      this.toggleChildren(index);
    }
  }

  toggleSidebar(event: MouseEvent): void {
    event.stopPropagation();
    const newState = !this.isClosed;
    this.globalService.updateIsSideMenuClosed(newState);

    if (newState) {
      this.menuItems.forEach((item) => (item.childrenOpen = false));
    }
  }

  toggleChildren(index: number): void {
    this.menuItems.forEach((item, i) => {
      if (i === index) item.childrenOpen = !item.childrenOpen;
      else item.childrenOpen = false;
    });
  }

  getIconSrc(item: MenuItem): string {
    const isActive = this.router.url
      .toLowerCase()
      .includes(item.label.toLowerCase().replace(/\s+/g, '-'));
    return isActive ? item.icon.replace('.svg', '-active.svg') : item.icon;
  }

  openSupportPopup(event: Event) {
    event.preventDefault();
    this.showSupportPopup = true;
  }

  // Handle the close event coming from the child
  handleSupportClose() {
    this.showSupportPopup = false;
  }
}
